import { render } from "./MyLeaveMessageView.vue?vue&type=template&id=ae09ab6e&scoped=true"
import script from "./MyLeaveMessageView.vue?vue&type=script&lang=js"
export * from "./MyLeaveMessageView.vue?vue&type=script&lang=js"

import "./MyLeaveMessageView.vue?vue&type=style&index=0&id=ae09ab6e&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae09ab6e"]])

export default __exports__